import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { logOut } from "./globalSlice";
import Api from "../api/api";
import { RootState } from "./store";
import { addPaginatedCollectionReducers, PaginatedCollectionState, usePaginatedCollection } from "./paginatedCollection";
import { Points, PointSpending, PointTopup } from "../api/models";
import { addEntityFetchReducers, EntityState } from "./entity";
import { FetchableState, useFetchableState } from "./fetchableState";
import { redeemCodeThunk, redemptionsThunk, redemptionThunk } from "./redemptionsSlice";


type PointsState = FetchableState<Points>

const pointsInitialState: PointsState = {}

export const pointsSlice = createSlice({
    name: 'points',
    initialState: pointsInitialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(pointsThunk.pending, (state, action) => {
            if (state.currentRequestId)
                return
            state.currentRequestId = action.meta.requestId
        })
        builder.addCase(pointsThunk.fulfilled, (state, action) => {
            if (state.currentRequestId !== action.meta.requestId)
                return
            state.currentRequestId = undefined
            state.data = action.payload.points
        })
        builder.addCase(pointsThunk.rejected, (state, action) => {
            if (state.currentRequestId !== action.meta.requestId)
                return
            state.currentRequestId = undefined
            state.error = action.error
        })
        builder.addCase(logOut, (state) => {
            state = pointsInitialState;
        })
    },
})

export const pointsThunk = createAsyncThunk('points/fetchPoints', async ({ accessToken }: { accessToken: string }, { getState, requestId }) => {
    const state = getState() as RootState;   // avoid sending request if it's going to be discarded anyway
    const currentRequestId = state.points.currentRequestId
    if (currentRequestId !== requestId)
        throw new Error("Request outdated");
    return await Api.getPoints({ accessToken })
})

export const usePoints = (accessToken: string) => {
    return useFetchableState<Points>({
        selector: (state: RootState) => state.points,
        action: pointsThunk({ accessToken })
    })
}


export default pointsSlice.reducer